export default __webpack_public_path__ + "static/media/liquimoly_logo_black.3640ce03.png";